export default __webpack_public_path__ + "static/media/drink_circles.05c4e388.png";